



































import { computed, defineComponent, ref } from "@vue/composition-api"
import { useFindOneBooking, useStopBooking } from "@/app/reactive/booking"
import Subtitle from "@/app/components/common/Subtitle.vue"
import Content from "@/app/components/common/Content.vue"
import Hint from "@/app/components/common/Hint.vue"
import BookingGateControls from "./BookingGateControls.vue"
import { FacilityModel } from "@/app/models/facility.model"
import BookingDetailInfoBox from "@/app/components/booking/BookingDetailInfoBox.vue"

export default defineComponent({
  name: "BookingStarted",
  components: {
    Subtitle,
    Content,
    Hint,
    BookingGateControls,
    BookingDetailInfoBox,
  },
  props: {
    facility: {
      type: Object as () => FacilityModel,
      required: true,
    },
  },
  setup(_, { root }) {
    const { stopBooking, isStopBookingPending, stopBookingError } = useStopBooking()
    const { booking } = useFindOneBooking()
    const isConfirmDialogOpen = ref(false)

    const stopBookingErrorText = computed(() => {
      if (stopBookingError.value === "BookingHasActiveServiceTransactionException") {
        return root.$t("booking.detail.finish.activeServiceTransaction")
      }
      return root.$t("booking.detail.finish.stopError")
    })

    const closeDialog = () => (isConfirmDialogOpen.value = false)
    const openDialog = () => (isConfirmDialogOpen.value = true)

    async function stop() {
      await stopBooking(booking)
      closeDialog()
    }

    return {
      booking,
      openDialog,
      closeDialog,
      stop,
      isConfirmDialogOpen,
      isStopBookingPending,
      stopBookingError,
      stopBookingErrorText,
    }
  },
})
